<div class="modal-content-container">
  <a id="close-dialog-alta" class="close-dialog" (click)="closeDialog()">
    <img src="assets/images/icons/close_dialog_icon.svg" alt="close">
  </a>
  <div class="inactivity-title">
    <div class="title margin-fix">
     {{translations["Usuario y contrasena bloqueados"]}}
    </div>
  </div>
  <div class="modal-body-blocked" style="text-align: justify;">
    {{translations["Superaste el numero de intentos permitidos"]}}. {{translations["Por seguridad"]}}, <strong>{{translations["deshabilitamos tus accesos"]}}.</strong>
  </div>
  <p class="margin-fix">
    {{translations["Para recuperar tus accesos"]}},
    <strong>gac@monex.com.mx</strong> {{translations["con los siguientes datos"]}}:
  </p>
  <div style="text-align:justify">
    <p class="margin-fix space-left italic"> {{translations["Asunto"]}}: {{translations["Desbloqueo de usuario y contrasena"]}}</p>
    <ul>
      <li>{{translations["Numero de contrato"]}}</li>
      <li>{{translations["Nombre completo del Titular del contrato"]}}</li>
      <li>{{translations["Nombre completo del Participante del contrato"]}}</li>
    </ul>
    <div>
      {{translations["utiliza el mismo correo que autorizaste en el sistema"]}} 
    </div>
  </div>
</div>
